import { render, staticRenderFns } from "./newLayout.vue?vue&type=template&id=7425e5a5&"
import script from "./newLayout.vue?vue&type=script&lang=js&"
export * from "./newLayout.vue?vue&type=script&lang=js&"
import style0 from "./newLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports